import type { WisetackSettings } from '@/types/settings';

export const WISETACK_FORM_ID = 'wisetack-settings-form';

export const WISETACK_DEFAULT_SETTINGS: WisetackSettings = {
  enabled: false,
  environment: 'mock',
  partnerName: null,
  signupUrl: null,
  prequalLink: null,
  enrollmentState: 'not_configured',
  merchantId: null,
  merchantExternalId: null,
  transactionRange: null,
  pricingPlan: null,
  requestedDocuments: null,
  merchantBusinessName: null,
  merchantDoingBusinessAs: null,
  transactionsEnabled: false,
  statusSimulatorEnabled: false,
  lastMerchantReportAt: null,
  statusDates: {
    inProgressAt: null,
    submittedAt: null,
    approvedAt: null,
    declinedAt: null,
    expiredAt: null,
  },
};
